var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 21,
    viewBox: "0 0 31 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0654 0.412598H2.06543C0.96086 0.412598 0.0654297 0.972242 0.0654297 1.6626C0.0654297 2.35295 0.96086 2.9126 2.06543 2.9126H28.0654C29.17 2.9126 30.0654 2.35295 30.0654 1.6626C30.0654 0.972242 29.17 0.412598 28.0654 0.412598Z",
    fill: "#58595B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5854 9.1626H1.54543C0.728048 9.1626 0.0654297 9.72224 0.0654297 10.4126C0.0654297 11.103 0.728048 11.6626 1.54543 11.6626H20.5854C21.4028 11.6626 22.0654 11.103 22.0654 10.4126C22.0654 9.72224 21.4028 9.1626 20.5854 9.1626Z",
    fill: "#58595B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5854 17.9126H1.54543C0.728048 17.9126 0.0654297 18.4722 0.0654297 19.1626C0.0654297 19.853 0.728048 20.4126 1.54543 20.4126H14.5854C15.4028 20.4126 16.0654 19.853 16.0654 19.1626C16.0654 18.4722 15.4028 17.9126 14.5854 17.9126Z",
    fill: "#58595B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.9d4e368f.svg";
export { ForwardRef as ReactComponent };